import Reveal from "./Reveal";
import { Link } from "react-router-dom";
import { PRICING } from "../data/site";

function PriceTable({ title, rows, tag }) {
  return (
    <div data-testid={`price-table-${tag}`} className="border-t border-black/15 pt-8">
      <div className="flex items-baseline justify-between">
        <h4 className="font-display text-2xl md:text-3xl font-light">{title}</h4>
        <span className="overline text-[color:var(--bs-muted)]">Tarif public</span>
      </div>
      <div className="mt-6 divide-y divide-black/10">
        {rows.map((r) => (
          <div
            key={r.d + r.p}
            className="flex items-baseline justify-between py-4"
          >
            <span className="font-display text-2xl md:text-3xl font-light text-[color:var(--bs-ink)]">
              {r.d}
            </span>
            <span className="text-lg md:text-xl text-[color:var(--bs-gold)] font-mono">
              {r.p}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function PricingSection({ compact = false, hideHeader = false }) {
  return (
    <section
      id="tarifs"
      data-testid="pricing-section"
      className="py-24 md:py-32 bg-[color:var(--bs-bg)]"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10">
        {!hideHeader && (
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
            <Reveal className="md:col-span-8">
              <div className="overline text-[color:var(--bs-muted)]">Tarifs</div>
              <h2 className="mt-6 font-display text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[0.95] text-[color:var(--bs-ink)]">
                Nos <span className="italic text-[color:var(--bs-gold)]">tarifs</span>.
              </h2>
            </Reveal>
            <Reveal className="md:col-span-4" delay={0.1}>
              <p className="text-[color:var(--bs-muted)] leading-relaxed font-light">
                Tarifs indiqués pour le vol complet (tous passagers compris). Vols
                VIP, restaurant, mariage et entreprise sur devis personnalisé.
              </p>
            </Reveal>
          </div>
        )}

        <div className={hideHeader ? "" : "mt-20 md:mt-24"}>
          <Reveal>
            <div className="overline text-[color:var(--bs-muted)] mb-8">
              — Initiation au pilotage
            </div>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-20">
            <Reveal>
              <PriceTable
                tag="init-r22"
                title="R22 · stagiaire + instructeur"
                rows={PRICING.initiation_r22}
              />
            </Reveal>
            <Reveal delay={0.1}>
              <PriceTable
                tag="init-r44"
                title="R44 · stagiaire + instructeur + 2 accompagnants"
                rows={PRICING.initiation_r44}
              />
            </Reveal>
          </div>

          <Reveal>
            <div className="overline text-[color:var(--bs-muted)] mt-24 mb-8">
              — Baptême de l'air
            </div>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
            <Reveal>
              <PriceTable
                tag="bap-r22"
                title="R22 · 1 passager"
                rows={PRICING.bapteme_r22}
              />
            </Reveal>
            <Reveal delay={0.08}>
              <PriceTable
                tag="bap-r44"
                title="R44 · jusqu'à 3 passagers"
                rows={PRICING.bapteme_r44}
              />
            </Reveal>
            <Reveal delay={0.16}>
              <PriceTable
                tag="bap-as350"
                title="AS350 · jusqu'à 5 passagers"
                rows={PRICING.bapteme_as350}
              />
            </Reveal>
          </div>

          <Reveal>
            <div className="mt-24 border-t border-black/15 pt-8 grid grid-cols-1 md:grid-cols-12 gap-6">
              <div className="md:col-span-6">
                <div className="overline text-[color:var(--bs-muted)]">Sur devis</div>
                <h3 className="mt-4 font-display text-3xl md:text-5xl font-light">
                  Transports VIP, Restaurant, Mariage, Entreprise
                </h3>
              </div>
              <div className="md:col-span-5 md:col-start-8 text-[color:var(--bs-muted)] leading-relaxed font-light">
                <p>
                  Ces missions se composent avec vous : itinéraire, appareil,
                  timing, prestations complémentaires. Un devis dédié vous est
                  adressé sous 24–48 h.
                </p>
                <Link
                  to="/reservation"
                  data-testid="pricing-quote-cta"
                  className="btn-gold mt-6 w-fit"
                >
                  Demander un devis
                  <span aria-hidden>→</span>
                </Link>
              </div>
            </div>
          </Reveal>
        </div>

        {!compact && (
          <Reveal>
            <div className="mt-24 border-t border-black/10 pt-8 text-xs text-[color:var(--bs-muted)] font-light leading-relaxed max-w-3xl">
              <p>
                Le budget indiqué correspond au vol complet, non par passager.
                Restrictions de poids : R22 — stagiaire 90 kg ; R44 — 120 kg par
                personne ; AS350 — 150 kg par passager.
              </p>
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}
